<template>
  <div class="customer-notes">
    <div class="customer-notes__body">
      <inline-button v-if="_events['delete-note']" label="Delete" class="desktop-only-inline-block"
        type="plain-danger responsive-column form-height wide" @click="$emit('delete-note')" :disabled="!isEdit" />
      <div v-for="input in notesInputs" :key="input.id" :class="'input-text ' + input.class">
        <Input :model="note[input.id]" @updateModel="note[input.id] = $event" :inputData="input" :isEdit="isEdit"
          v-if="input.id !== 'showPopUp' || (input.id === 'showPopUp' && showPopUpCheckbox())" />
      </div>
    </div>
  </div>
</template>

<script>
import { notesInputs } from "@/views/Customer/inputs";
import Input from "@/components/Input/Input.vue";

export default {
  name: "CustomerNote",
  props: {
    isEdit: {
      type: Boolean,
    },
    note: {
      type: Object,
    },
  },
  components: { Input },
  watch: {
    "note.noteType": {
      handler(newVal) {
        if (newVal !== "pop-up-message" && this.note.showPopUp) {
          this.note.showPopUp = false;
        }
        else if (newVal === "pop-up-message" && !this.note.showPopUp) {
          this.note.showPopUp = true;
        }
      },
    },
  },
  data() {
    return {
      notesInputs,
    };
  },
  methods: {
    showPopUpCheckbox() {
      return this.note?.noteType === "pop-up-message" || this.note?.noteType === "dosage" || this.note?.noteType?.code === "dosage" || this.note?.noteType?.code === "pop-up-message";
    }
  },
};
</script>

<style scoped lang="scss">
.customer-notes {
  width: 100%;

  &__body {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;

    @include respond(tab-port) {
      display: flex;
      flex-direction: column;
    }
  }
}

.grid-row-two-column {
  grid-column: span 2;
  width: 100%;
}
</style>
